import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=fdfb901c&scoped=true&"
import script from "./WarningModal.vue?vue&type=script&lang=js&"
export * from "./WarningModal.vue?vue&type=script&lang=js&"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=fdfb901c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb901c",
  null
  
)

export default component.exports